import { useState, useEffect } from "react";

function extractColor(imageUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = 20;
        canvas.height = 20;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, 20, 20);
        const { data } = ctx.getImageData(0, 0, 20, 20);

        let r = 0, g = 0, b = 0, count = 0;
        for (let i = 0; i < data.length; i += 4) {
          const pr = data[i], pg = data[i + 1], pb = data[i + 2];
          const brightness = (pr + pg + pb) / 3;
          // Skip near-black and near-white pixels
          if (brightness < 30 || brightness > 220) continue;
          r += pr; g += pg; b += pb; count++;
        }

        if (count === 0) { resolve(null); return; }
        resolve((Math.round(r / count) << 16) | (Math.round(g / count) << 8) | Math.round(b / count));
      } catch {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = imageUrl;
  });
}

export default function useDominantColor(imageUrl) {
  const [color, setColor] = useState(null);

  useEffect(() => {
    if (!imageUrl) { setColor(null); return; }
    extractColor(imageUrl).then(setColor);
  }, [imageUrl]);

  return color; // hex number like 0xRRGGBB, or null
}
